import { render } from "./RightModalWidget.vue?vue&type=template&id=07bbf41e"
import script from "./RightModalWidget.vue?vue&type=script&lang=js"
export * from "./RightModalWidget.vue?vue&type=script&lang=js"

import "./RightModalWidget.vue?vue&type=style&index=0&id=07bbf41e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__